// externals
import type { RouteComponentProps } from 'react-router';

// libraries
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// routing
import { Routes } from './routes';
import { useSelector } from 'react-redux';

// types
import type { ChooseVehicleStateTree } from '../types/stateTreeTypes';

export const Routing: React.FC<RouteComponentProps> = (props) => {
    const toggles = useSelector((state: ChooseVehicleStateTree) => featureToggleSelectors.getFeatureToggles(state as any));

    return <Routes toggles={toggles} {...props} />;
};
